import { render, staticRenderFns } from "./ApprovesList.vue?vue&type=template&id=9c2ab59e&scoped=true&"
import script from "./ApprovesList.vue?vue&type=script&lang=js&"
export * from "./ApprovesList.vue?vue&type=script&lang=js&"
import style0 from "./ApprovesList.vue?vue&type=style&index=0&id=9c2ab59e&lang=scss&scoped=true&"
import style1 from "./ApprovesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2ab59e",
  null
  
)

export default component.exports